import * as ActionTypes from "./actionTypes";
import { getPromotionItems } from "../actions/promotionActions";
import { getStockItemToAdd } from "../actions/promotionActions";
import * as urls from "../common/urls";
import axios from "axios";


//const secondAction = (data) => ({
//    type: 'SECOND',
//    payload: { ...},
//})

//const firstAction = () => {
//    return (dispatch) => {
//        const response = dispatch({
//            type: 'FIRST',
//            payload: new Promise(...),
//        })

//        response.then((data) => {
//            dispatch(secondAction(data))
//        })
//    }
//}

export function addToCart(selectedProduct, quantity, originalPrice, specialPrice, stockItemId, loyaltyPoints, isPromo = false) {
    const product = {
        id: selectedProduct.id, title: selectedProduct.title, groupId: selectedProduct.groupId, groupName: selectedProduct.groupName,
        originalPrice: selectedProduct.originalPrice, specialPrice: selectedProduct.specialPrice, stockItemCode: selectedProduct.stockItemCode, thumbnail: selectedProduct.thumbnail,
        loyaltyPoints: selectedProduct.loyaltyPoints
    };

  //return {
  //  type: ActionTypes.ADD_TO_CART,
  //    payload: new Promise(function (resolve, reject) { resolve({ product, quantity, originalPrice, specialPrice, stockItemId }); })
  //  };

    return (dispatch, getState) => {
        //console.log('state', getState());

        const response = dispatch({
            type: ActionTypes.ADD_TO_CART,
            payload: new Promise(function (resolve, reject) { resolve({ product, quantity, originalPrice, specialPrice, stockItemId, loyaltyPoints, isPromo }); })
        });

        response.then(() => {
            const { cart, user } = getState();
            if (user.isAuthenticated === true) {
                dispatch(saveCart(cart))
            }
        })
    }
}


export function updateCart(stockItemId, quantity, isPromo = false, isLoyaltyPointsUsed = false) {
    //return {
    //    type: ActionTypes.UPDATE_CART,
    //    payload: new Promise(function (resolve, reject) { resolve({ productId, quantity }); })
    //};

    return (dispatch, getState) => {
        const response = dispatch({
            type: ActionTypes.UPDATE_CART,
            payload: new Promise(function (resolve, reject) { resolve({ stockItemId, quantity,isPromo, isLoyaltyPointsUsed }); })
        });

        response.then(() => {
            const { cart, user } = getState();
            if (user.isAuthenticated === true) {
                dispatch(saveCart(cart))
            }
        })
    }
}

export function removeFromCart({ stockItemId, isPromo }) {

    return (dispatch, getState) => {
        const response = dispatch({
            type: ActionTypes.REMOVE_FROM_CART,
            payload: new Promise(resolve =>
                resolve({ stockItemId, isPromo })
            )
        });

        response.then(() => {
            const { cart, user } = getState();
            if (user.isAuthenticated) {
                dispatch(saveCart(cart));
            }
        });
    };
}

export function emptyCart() {
    //return {
    //    type: ActionTypes.EMPTY_CART,
    //    payload: new Promise(function (resolve, reject) { resolve(null); })
    //};

    return (dispatch, getState) => {

        const response = dispatch({
            type: ActionTypes.EMPTY_CART,
            payload: new Promise(function (resolve, reject) { resolve(null); })
        });

        response.then(() => {
            const { cart, user } = getState();
            if (user.isAuthenticated === true) {
                dispatch(saveCart(cart))
            }
        })
    }
}

export function setCart(cart) {
    cart.isDefault = true;
    cart.id = 0;
    return { type: ActionTypes.SET_CART, payload: new Promise(function (resolve, reject) { resolve(cart); })};
}

// SAVE CART To Server
export function getCart(userId, cartUrl, isDefault) {
    const url = `${urls.GET_CARTS_URL}?userId=${userId}${'&cartUrl=' + (cartUrl ? cartUrl: '')}${'&isDefault=' + isDefault }`;
    const request = axios.get(url);
    return { type: ActionTypes.GET_CART, payload: request };

}

export function loadCartByUrl(cartUrl) {
    const url = `${urls.GET_CARTS_URL}/byurl/${cartUrl}`;
    const request = axios.get(url);
    return { type: ActionTypes.LOAD_CART_BY_URL, payload: request };

}

export const getCarts = () => async (dispatch, getState) => {
    try {
        const url = `${urls.GET_CARTS_URL}?userId=${user.id}&cartUrl=&isDefault=false`;
        const response = await axios.get(url);

        let savedCart = response.data;
        savedCart.lines = savedCart.cartJson ? JSON.parse(savedCart.cartJson) : savedCart.lines;

        const { checkoutSale, user, shipping, payment, discountCode, settings } = getState();

        const itemDetails = checkoutSale?.itemDetails ?? [];
        const itemIds = new Set(itemDetails.map(i => i.stockItemId));

        const originalLines = savedCart.lines ?? [];

        // 2 Detect removed promo lines
        const removedPromoLines = originalLines.filter(
            line => line.isPromo && !itemIds.has(line.stockItemId)
        );

        // 3 Keep only valid promos in cart
        savedCart.lines = originalLines.filter(
            line => !line.isPromo || itemIds.has(line.stockItemId)
        );

        // 4 Dispatch cart to reducer
        dispatch({
            type: ActionTypes.GET_CART + ActionTypes.FULFILLED,
            payload: { data: savedCart },
        });

        // 5 Build sale from current state
        const sale = buildSaleFromState(getState());
        if (!sale) return;

        const saleRes = await dispatch(buildCheckoutSale(sale));
        const updatedSale = saleRes?.value?.data || saleRes;
        dispatch(storeCheckoutSale(updatedSale));

        // 6 Get promotions
        const promotionRes = await dispatch(getPromotionItems(updatedSale, 1));
        const promotions = promotionRes?.value?.data?.items || [];

        // 7 Re-add removed promo items using promotion data
        for (const line of removedPromoLines) {
            // Match removed line with promotion
            const promotion = promotions.find(
                p => p.StockItem?.Id === line.stockItemId
            );
            if (!promotion) continue; // skip if not found

            const payload = {
                allowHostGiftSystems: false,
                allowUpdate: true,
                discountCodesSettingId: null,
                promoStockItemId: promotion.PromotionStockItem?.Id || null,
                sale: updatedSale,
                stockItemCode: promotion.StockItem?.StockCode || null,
                stockItemId: promotion.StockItem?.Id || null,
            };

            try {
                const res = await dispatch(getStockItemToAdd(payload));
                const data = res?.value?.data;
                dispatch(storeCheckoutSale(data.sale));

                const promotionData = data.promotionData;
                const selectedProduct = {
                    ...promotionData.product,
                    title: promotionData.title,
                    originalPrice: promotionData.originalPrice,
                    specialPrice: promotionData.specialPrice,
                    stockItemCode: promotionData.stockItemCode,
                    stockItemId: promotionData.stockItemId,
                    quantity: promotionData.quantity,
                };

                dispatch(
                    addToCart(
                        selectedProduct,
                        selectedProduct.quantity,
                        selectedProduct.originalPrice,
                        selectedProduct.specialPrice,
                        selectedProduct.stockItemId,
                        selectedProduct.loyaltyPoints,
                        true
                    )
                );
            } catch (err) {
                console.error("Promo recovery failed:", err);
            }
        }
    } catch (err) {
        console.error("getCarts failed:", err);
    }
};
export function saveCart(cart, saveAs, newName) {
  
    const cartObj = { ...cart, cartJson: JSON.stringify(cart.lines) }
    if (saveAs) {
        cartObj.isDefault = false;
        cartObj.name = newName;
    }
    const request = axios.post(urls.SAVE_CART_URL, cartObj);

    return { type: ActionTypes.SAVE_CART, payload: request };
}

function buildSaleFromState(state) {

    const { checkoutSale, cart, user, shipping, discountCode, settings } = state;

    const itemDetails = checkoutSale?.itemDetails ?? [];

    const cartMap = new Map(
        cart.lines.map(line => [
            `${line.stockItemId}-${line.isPromo}`,
            line.quantity
        ])
    );

    const updatedExistingItems = itemDetails.map(item => ({
        ...item,
        quantity: cartMap.get(`${item.stockItemId}-${item.isPromotion}`) ?? item.quantity
    }));

    const saleTotal = checkoutSale?.saleTotalAfterDiscount ?? 0;
    const saleTotalAsInt = checkoutSale?.saleTotalAfterDiscountAsInt ?? 0;

    return {
        customerId: user.id,
        stockItems: updatedExistingItems,
        customerTypeId: 2,
        totalPaid: saleTotal,
        totalPaidAsInt: saleTotalAsInt,
        amount: saleTotal,
        discountCode,
        address1: shipping?.address1,
        address2: shipping?.address2,
        address3: shipping?.address3,
        address4: shipping?.address4,
        postCode: shipping?.postCode,
        regionId: shipping?.regionId,
        regionName: shipping?.regionName,
        firstName: shipping?.firstName,
        lastName: shipping?.lastName,
        organization: shipping?.organization,
        deliveryServiceId: settings?.deliveryServiceId
    };
}

export function removeCart(userId, cartUrl) {
    const url = `${urls.GET_CARTS_URL}/${cartUrl}`;
    const request = axios.delete(url);
    return { type: ActionTypes.REMOVE_CART, payload: request };
}

// END SAVE CART To Server

export function addToWishlist(product) {
  return { type: ActionTypes.ADD_TO_WISHLIST, payload: product };
}

export function removeFromWishlist(productId) {
  return { type: ActionTypes.REMOVE_FROM_WISHLIST, payload: productId };
}

export function emptyWishlist() {
    return { type: ActionTypes.EMPTY_WISHLIST, payload: null };
}